import type { ProductUnsecuredLoanConfig } from '../../@types/context/product-unsecured-loan-config.types';

export const unsecuredLoansSeConfig: Omit<
  ProductUnsecuredLoanConfig,
  'fields'
> = {
  rates: {
    low: 7.9,
    mid: 12,
    high: 16,
    startup_fee: 495,
    interest_rate: 0.0695,
    monthly_fee: 0,
  },
  config: {
    amount: {
      min: 5_000,
      max: 800_000,
      default: 500_000,
      step: 5_000,
    },
    duration: {
      min: 1,
      max: 15,
      default: 15,
      step: 1,
    },
  },
};
